// 养老接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 线索管理-列表
export const getLiveClueList = (params) => post(`${baseApi}/clue/getClues`, params);
// 线索管理-筛选选项
export const getLiveClueOptions = (params) => get(`${baseApi}/clue/getCluesSearchItems`, params);
// 线索管理-乳腺癌筛选选项集合
export const getRxaOptions = (params) => get(`${apiPrefix.telemarketingApi}/customer/breastCancerManualFieldOptions`, params);
// 线索管理 - 获取优化师选项列表
export const getUserNameOptions = (params) => get(`${baseApi}/ffxLaunch/getUserList`, params);
// 线索管理-互动状态修改
export const liveClueStatusUpdate = (params) => post(`${baseApi}/clue/updateClueStatus`, params);
// 线索管理-主播排期模板下载
export const liveClueDownSchduleTemplate = (params) => get(`${baseApi}/clue/exportWorkTimeMetal`, params, {responseType: "blob"});
// 线索管理-数据导出
export const liveClueExport = (params) => post(`${baseApi}/clue/downloadClues`, params, {responseType: "blob"});
// 线索管理-上传主播排期表
export const liveClueAnchorSchdueUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(`${baseApi}/clue/tkrxx/importWorkTime`, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
// 线索管理-获取核保材料详情
export const getLiveClueMaterialDetail = (params) => get(`${baseApi}/clue/tkrxx/queryUser`, params);
// 线索管理-核保材料更新
export const liveClueMaterialUpdate = (params) => post(`${baseApi}/clue/tkrxx/saveUser`, params);
// 线索管理-核保材料提交审核
export const liveClueMaterialReview = (params) => get(`${apiPrefix.ffxApi}/user/ffx/submit`, params);
// 线索管理 - 获取通话详情
export const getLiveClueCallDetail = (params) => get(`${baseApi}/monitorMenu/list`, params);




// 线索录入-获取户型月费
export const getClueYlMonthlyFee = (params) => get(`${baseApi}/cluesEnter/ylMonthlyFeeApi`, params);
// 线索录入-获取线索详情
export const getClueDetailFromPhone = (params) => get(`${baseApi}/cluesEnter/save`, params);
// 线索录入-单条新增
export const addClueEnter = (params) => post(`${baseApi}/cluesEnter/save`, params);
// 线索录入-上传批量添加模板
export const uploadBatchAddClueTemplate = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(baseApi + "/cluesEnter/tkrxx/analysis", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
// 线索录入-批量新增
export const batchAddClueEnter = (params) => get(`${baseApi}/cluesEnter/batchSave`, params);



// 企微排班管理 - 获取列表
export const getQywxShiftList = (params) => get(`${baseApi}/clue/qywxShift/list`, params);
// 企微排班管理 - 新增
export const qywxShiftAdd = (params) => post(`${baseApi}/clue/qywxShift/add`, params);
// 企微排班管理 - 保存
export const qywxShiftSave = (params) => post(`${baseApi}/clue/qywxShift/save`, params);
// 企微排班管理 - 保存班次
export const qywxShiftSaveShift = (params) => post(`${baseApi}/clue/qywxShift/saveShift`, params);
// 企微排班管理 - 下线
export const qywxShiftOffline = (params) => get(`${baseApi}/clue/qywxShift/offline`, params);
// 企微排班管理 - 启用
export const qywxShiftEnable = (params) => get(`${baseApi}/clue/qywxShift/enable`, params);

// 坐席跟进管理 - 获取坐席维度跟进汇总列表
export const getSeatFollowList = (params) => post(`${baseApi}/fufaxian/seat/follow/list`, params);
